import { css } from '@emotion/css';

export const scorecardStyles = css`
  .action-btn {
    opacity: 0;
  }
  :hover .action-btn {
    opacity: 1;
  }
`;
